module.exports = __webpack_public_path__ + "img/success.11c5352f.svg";